import { Component } from "react";

import LegacyDispatcher from "app/lib/legacyDispatcher";
import BuildRow from "app/components/build/BuildRow";

import BranchStore, { Branch, Project } from "app/stores/BranchStore";
import Icon from "app/components/shared/Icon";

type Props = {
  branch: Branch;
  project: Project;
  store: BranchStore;
};

// eslint-disable-next-line react/require-optimization
export default class BranchListBranch extends Component<Props> {
  render() {
    const starredClassName = this.props.branch.starred
      ? "better-branch-starred"
      : "better-branch-not-starred";

    return (
      <div
        className={`panel mb4 panel-default better-branch-panel ${starredClassName} mb6 border-none depth-150 rounded-1.5 antialiased`}
        data-branch={this.props.branch.name}
      >
        <div className="panel-heading flex items-center bg-slate-100 rounded-top-1.5 charcoal-700">
          <div className="flex-auto">
            <h2 className="flex items-center h4 m0 regular line-height-1">
              <Icon
                icon="custom/outline/14x/branch"
                className="mr0.5"
                style={{ height: 14, width: 14 }}
              />
              <a
                className="no-highlight-link better-branch-panel-name hover-color-inherit"
                href={this.props.branch.path}
              >
                {this.props.branch.name}
              </a>
            </h2>
          </div>
          <div className="flex">
            {this.renderStarButton()}
            {this.renderRemoveButton()}
          </div>
        </div>
        {this.props.branch.builds &&
          this.props.branch.builds.map((build) => (
            // @ts-expect-error - TS2740 - Type 'Build' is missing the following properties from type '{ id: string; authorName: string; blockedState: string | null; branchName: string; branchPath: string; canceledAt: string | null; commitId: string; commitShortLength: number; commitUrl: string; ... 10 more ...; project: { ...; }; }': blockedState, canceledAt, commitUrl, finishedAt, and 2 more. | TS2740 - Type 'BranchStore' is missing the following properties from type 'BuildsStore': database, query, reloadInProgress, reload, and 2 more.
            <BuildRow key={build.id} build={build} store={this.props.store} />
          ))}
      </div>
    );
  }

  renderStarButton() {
    if (this.props.project.permissions.favoriteProject.allowed) {
      if (this.props.branch.starred) {
        return (
          <a
            href="#"
            onClick={this.handleUnstarClick}
            className="better-branch-star-button no-title-tooltip"
            aria-label={`Unfavorite ${this.props.branch.name} branch`}
            title={`Unfavorite ${this.props.branch.name} branch`}
          >
            <i className="fa fa-star" />
          </a>
        );
      }
      return (
        <a
          href="#"
          onClick={this.handleStarClick}
          className="better-branch-star-button no-title-tooltip"
          aria-label={`Favorite ${this.props.branch.name} branch`}
          title={`Favorite ${this.props.branch.name} branch`}
        >
          <i className="fa fa-star-o" />
        </a>
      );
    }

    return null;
  }

  renderRemoveButton() {
    if (this.props.project.permissions.edit.allowed) {
      return (
        <a
          href="#"
          onClick={this.handleRemoveClick}
          className="better-branch-remove-button hover-color-inherit no-title-tooltip"
          aria-label={`Remove ${this.props.branch.name} branch`}
          title={`Remove ${this.props.branch.name} branch`}
        >
          <i className="fa fa-ban" />
        </a>
      );
    }
  }

  handleStarClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // @ts-expect-error - TS2554 - Expected 6 arguments, but got 2.
    LegacyDispatcher.emit("project_branch:star", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleUnstarClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // @ts-expect-error - TS2554 - Expected 6 arguments, but got 2.
    LegacyDispatcher.emit("project_branch:unstar", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleRemoveClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (confirm("Remove this branch until new builds are pushed?")) {
      this.props.store.removeBranch(this.props.branch.name);
    }
  };
}
